module.exports = __webpack_public_path__ + "img/gb9119_4.prt.f80b1d0e.jpg";